import { useTheme as useThemeFromContext } from '../stores/ThemeContext';

export const useTheme = () => {
  return useThemeFromContext();
};